var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamioneta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "47. Delivery car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "47.-Delivery-car",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8559233,11 C60.7471261,11 63.0909091,13.3516833 63.0909091,16.2363971 L63.0909091,63.3636364 L2,63.3636364 L2,15.9971256 C2,13.2372893 4.24141221,11 7.00599677,11 L57.8559233,11 Z",
    id: "Layer-1",
    stroke: "#f4f7f7",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2727273,80.8181818 L95.3761444,80.8181818 C96.82853,80.8181818 98,79.6495953 98,78.2080708 L98,61.610111 C98,60.1730402 97.2631111,58.0897908 96.3541125,56.9669909 L81.9822805,39.2148272 C81.0728879,38.0915406 79.1637293,37.1818182 77.7171752,37.1818182 L63.0909091,37.1818182 L63.0909091,80.8181818 L71.8181818,80.8181818 C71.8181818,75.9982422 75.7255149,72.0909091 80.5454545,72.0909091 C85.3653942,72.0909091 89.2727273,75.9982422 89.2727273,80.8181818 L89.2727273,80.8181818 Z",
    id: "Layer-2",
    stroke: "#f7fafa",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8181818,48.9121885 C71.8181818,47.2536235 73.1526762,45.9090909 74.8123151,45.9090909 L87.1582386,45.9090909 L98,58.8823864 L98,61.5806818 L74.8215693,61.5806818 C73.1628442,61.5806818 71.8181818,60.2445308 71.8181818,58.5775842 L71.8181818,48.9121885 Z",
    id: "Layer-3",
    stroke: "#fcfcfc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6,80.8181818 L7.23498576,80.8181818 C4.33878705,80.8181818 2,78.4735243 2,75.5812426 L2,63.3636364 L63.0909091,63.3636364 L63.0909091,80.8181818 L29.0545455,80.8181818 C29.0545455,75.9982422 25.1472124,72.0909091 20.3272727,72.0909091 C15.5073331,72.0909091 11.6,75.9982422 11.6,80.8181818 L11.6,80.8181818 Z",
    id: "Layer-4",
    stroke: "#f5f9fa",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Layer-5",
    stroke: "#f7fbfc",
    strokeWidth: 4,
    cx: 20.3272727,
    cy: 80.8181818,
    r: 8.72727273
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Layer-6",
    stroke: "#ebf3f5",
    strokeWidth: 4,
    cx: 80.5454545,
    cy: 80.8181818,
    r: 8.72727273
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamioneta);
export default __webpack_public_path__ + "static/media/camioneta.5338797ac04840b1b3be439ac2a94313.svg";
export { ForwardRef as ReactComponent };